import emailjs from '@emailjs/browser'

// EmailJS configuration
const EMAILJS_PUBLIC_KEY = import.meta.env.VITE_EMAILJS_PUBLIC_KEY || 'YOUR_PUBLIC_KEY'
const EMAILJS_SERVICE_ID = import.meta.env.VITE_EMAILJS_SERVICE_ID || 'YOUR_SERVICE_ID'
// For now, use the same template ID. You can create a separate bug template and use VITE_EMAILJS_BUG_TEMPLATE_ID later
const EMAILJS_BUG_TEMPLATE_ID = import.meta.env.VITE_EMAILJS_TEMPLATE_ID || 'YOUR_BUG_TEMPLATE_ID'

// Initialize EmailJS (in case it wasn't initialized elsewhere)
emailjs.init(EMAILJS_PUBLIC_KEY)

export interface BugReportData {
  email: string
  bugType: string
  description: string
  steps?: string
  expectedBehavior?: string
  browser?: string
  url: string
  userAgent: string
  timestamp: string
}

export async function sendBugReport(data: BugReportData): Promise<{ success: boolean; error?: string }> {
  try {
    // Template parameters for EmailJS
    const templateParams = {
      from_email: data.email,
      bug_type: data.bugType,
      description: data.description,
      steps: data.steps || 'Not provided',
      expected_behavior: data.expectedBehavior || 'Not provided',
      browser: data.browser || 'Not specified',
      current_url: data.url,
      user_agent: data.userAgent,
      timestamp: new Date(data.timestamp).toLocaleString(),
      to_email: 'vincentmasci@icloud.com',
      reply_to: data.email,
    }

    const response = await emailjs.send(
      EMAILJS_SERVICE_ID,
      EMAILJS_BUG_TEMPLATE_ID,
      templateParams
    )

    if (response.status === 200) {
      return { success: true }
    } else {
      return { success: false, error: 'Failed to send bug report. Please try again.' }
    }
  } catch (error) {
    console.error('Bug report service error:', error)
    return { 
      success: false, 
      error: 'Failed to send bug report. Please email us directly at vincentmasci@icloud.com' 
    }
  }
}